import { useTranslation } from 'react-i18next';
import { activityApi } from '../../api/endpoints.js';
import { useApi } from '../../hooks/useApi.js';
import PageHeader from '../../components/PageHeader.jsx';
import DataTable from '../../components/DataTable.jsx';
import Badge from '../../components/Badge.jsx';
import { formatDateTime, fullName } from '../../utils/format.js';

/** Append-only activity feed produced by the API on every meaningful action. */
const AuditLogPage = () => {
  const { t, i18n } = useTranslation();
  const { data, loading } = useApi(() => activityApi.list({ pageSize: 100 }), []);

  const columns = [
    {
      key: 'createdAt',
      header: t('common.date'),
      render: (row) => formatDateTime(row.createdAt, i18n.resolvedLanguage),
    },
    { key: 'type', header: t('common.actions'), render: (row) => <code>{row.type}</code> },
    {
      key: 'author',
      header: t('leads.createdBy'),
      render: (row) => (
        <div className="cell-stack">
          <span>{fullName(row.author)}</span>
          {row.author ? <Badge value={row.author.role} label={t(`roles.${row.author.role}`)} /> : null}
        </div>
      ),
    },
    { key: 'customerName', header: t('customers.companyName'), render: (row) => row.customerName ?? '-' },
    { key: 'message', header: t('common.notes') },
  ];

  return (
    <>
      <PageHeader title={t('nav.auditLog')} subtitle={`${data?.pagination?.total ?? 0} ${t('common.results')}`} />
      <DataTable columns={columns} rows={data?.items} loading={loading} emptyTitle={t('common.noData')} />
    </>
  );
};

export default AuditLogPage;
